<div id="login" fxLayout="column">

    <div id="login-form-wrapper" fxLayout="column" fxLayoutAlign="center center">
        <p-toast [showTransformOptions]="'translateX(100%)'"></p-toast>

        <div id="login-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">

            <div class="logo">
                <img src="assets/images/logos/qualisys.svg">
            </div>

            <div class="title">{{'AUTH.TITLE' | translate }}</div>

            <form name="loginForm" [formGroup]="loginForm" novalidate (ngSubmit)="onSubmit()">

                <mat-form-field appearance="outline">
                    <mat-label>{{'AUTH.USERNAME' | translate }}</mat-label>
                    <input matInput formControlName="username" id="username">
                    <mat-icon matSuffix class="secondary-text">mail</mat-icon>
                    <mat-error id="error-username" *ngIf="loginForm.get('username').hasError('required')">
                        {{'AUTH.USERNAME_REQUIRED' | translate }}
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label> {{'AUTH.PASSWORD' | translate }}</mat-label>
                    <input matInput type="password" formControlName="password" id="password">
                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                    <mat-error id="error-pwd">
                        {{'AUTH.PASSWORD_REQUIRED' | translate }}
                    </mat-error>
                </mat-form-field>

                <!-- <div class="remember-forgot-password" fxLayout="row" fxLayout.xs="column"
                    fxLayoutAlign="space-between center">
                    <mat-checkbox class="remember-me" formControlName="remember" aria-label="Remember Me">
                        Remember Me
                    </mat-checkbox>

                    <a class="forgot-password" > 
                        Forgot Password?
                    </a>
                </div> -->

                <button mat-raised-button color="accent" class="submit-button" [disabled]="loginForm.invalid"
                    id="btn-login">
                    {{ 'AUTH.LOGIN' | translate }}
                </button>

                <div class="powredBy">
                    <span>{{'App.POWERED_BY' | translate}} </span>
                    <a href="https://www.sama-consulting.com" target="_blank">{{'App.ENTREPRISE' | translate}}</a>
                </div>

            </form>

        </div>

    </div>

</div>